import { Component, OnInit, Output, ViewChild, EventEmitter, Inject } from '@angular/core';
import { Http, RequestOptions, Headers, Response } from '@angular/http';

declare var i18nVS: any;
declare var studentDesktopNamespace: any;
declare var cardsList: any;
declare var eliminarIkhlas: any;
declare var topUpCardURL: any;
declare var cardNumberParam: any;
declare var topUpAvailablesCitiesListJson: any;
declare var idCiudadLiferay: any;
declare var showRetrieveCard: any;
declare var URLLostCardPage: any;

@Component({
	selector: 'app-show-cards',
	templateUrl: './show-cards.component.html',
	styles: ['../student-desktop.component.css']
})

export class ShowCardsComponent implements OnInit {
	/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
	i18nL = i18nVS;
	namespacePortlet = studentDesktopNamespace;
	topUpCardURL = '';
	cardNumberParam = '';

	listaObjetosIkhlas = null;
	listaTarjetas = null;
	isShowCardsActive = true;
	visualizaMovimientos = false;

	// contendra los datos recibidos por el ResourceCommand que proporciona las tarjetas del usuario
	jsonData;
	codigoTarjetaSeleccionada;
	spinnerClass = "";
	// Lista de ciudades disponibles para hacer recargas
	topUpAvailablesCitiesList = null;
	showRetrieveCard = showRetrieveCard;
	URLLostCardPage = URLLostCardPage;

	@Output() onWebServiceError: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() loadStarted: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() loadStoped: EventEmitter<boolean> = new EventEmitter<boolean>();

	/*---------------------------------------------- Funciones ----------------------------------------------*/
	private resetView() {
		this.isShowCardsActive = false;
	}

	public showActiveCards() {
		this.resetView();
		this.isShowCardsActive = true;
	}

    /**
     * Llamada al ResourceCommand que proporciona las tarjetas del usuario
     */
	public initSelects() {
		console.log("Metodo 'initSelects' para llamada al ResourceCommand para obtener tarjetas del usuario");

		this.ajaxRequest.post(cardsList, new Map<string, string>()).subscribe(
			res => { this.validateJSON(res, cardsList) },
			(err) => this.errorEnElJson(err, cardsList),
			() => this.initCardList()
		);
	}

    /**
     * valida objetos JSON
     * @param res recurso a validar
     */
	public validateJSON(res: Response, url: string) {
		try {
			this.jsonData = res.json();
		} catch (error) {
			console.log(res);
			this.errorEnElJson("Error parseando el json", url);
		}
	}

    /**
     * Procesa errores detectados en el formato JSON
     */
	public errorEnElJson(err: string, url: string) {
		console.log('Error en la llamada: ' + err);
		console.log(url);
		this.onWebServiceError.emit(true);
	}

    /**
     * Inicializa el objeto que contendra la lista de tarjetas
     */
	public initCardList() {
		this.listaTarjetas = this.jsonData;
		// se quita el spinner
		this.spinnerClass = 'invisible';
	}

	public muestraMovimientos(numCard: string) {
		console.log("SERVICIO MOSTRAR MOVIMIENTOS " + numCard);

		// cuando hay movimientos mostrados y se quieren ver movimientos de otra tarjeta se quitan
		// los movimientos de la tarjeta anterior (se oculta la tabla)
		var movimientosTabla = (<HTMLDivElement>document.getElementById('tablaMovimientosTarjeta'));

		if (movimientosTabla != undefined) {    // se estan mostrando datos de otra tarjeta
			movimientosTabla.style.display = 'none';
		}

		// si se intenta buscar movimientos de una tarjeta que no ha sido seleccionada se indica que
		// se debe seleccionar una tarjeta
		var notificacion = (<HTMLDivElement>document.getElementById('avisoMovimientoNoSeleccionado'));

		if (notificacion != undefined) {
			notificacion.style.display = 'none';
		}

		// visualiza el componente de "movimientos"
		this.visualizaMovimientos = true;

		this.codigoTarjetaSeleccionada = numCard;

		// seleccion de fila de la tabla de muestra de tarjetas del usuario
		var rows = document.querySelectorAll("#tablaTarjetas tr");
		for (var i = 0; i < rows.length; i++) {
			rows[i].addEventListener('click', function() {
				[].forEach.call(rows, function(el) {
					el.classList.remove("highlight");
				});
				this.className += ' highlight';
			}, false);
		}
	}

	public recargaCard(numCard: string, cityID: string) {
		console.log("SERVICIO RECARGAR TARJETA " + numCard);
		console.log("Codigo de la ciudad de la tarjeta: " + cityID);

		(<HTMLFormElement>document.getElementById('topUpForm' + numCard)).submit();
	}


	public bajaCard(numCard: string, tipo: string) {
		console.log("Inicio metodo 'bajaCard' del componente 'ShowCardsComponent'");

		if (tipo.toString().toLowerCase() === "ikhlas") {
			this.eliminarTarjetaIkhlas(numCard);
		}

		this.quitarTarjetaDeLista(numCard);

		console.log("Fin metodo 'bajaCard' del componente 'ShowCardsComponent'");
	}

	// metodo de llamada al servicio que elimina tarjeta tipo ikhlas
	public eliminarTarjetaIkhlas(numeroTarjeta) {
		console.log("Inicio del metodo 'getTransacciones' del componente 'ShowMovimientosComponent'");

		var llamadaWS = (eliminarIkhlas + "&" + this.namespacePortlet + "cardNum=" + numeroTarjeta.toString()).toString();

		console.log("Se realizara la siguiente llamada: " + llamadaWS);

		this.ajaxRequest.get(llamadaWS, new Map<string, string>()).subscribe(
			res => { this.validateJSON(res, llamadaWS) },
			(err) => this.errorEnElJson(err, llamadaWS),
			() => console.log("La tarjeta '" + numeroTarjeta + "' se ha eliminado")
		);

		console.log("Fin del metodo 'getTransacciones' del componente 'ShowMovimientosComponent'");
	}

	// metodo de limpieza de la lista mostrada al eliminar tarjeta
	public quitarTarjetaDeLista(numTarjetaEliminada) {
		console.log("Se elimina la tarjeta seleccionada (" + numTarjetaEliminada + ") de los datos para que no se visualice la tarjeta eliminada");

		for (var index = 0; index < this.listaTarjetas.length; index++) {
			if (this.listaTarjetas[index].cardNumber == numTarjetaEliminada) {
				this.listaTarjetas.splice(index, 1);

				break;
			}
		}
	}

	public visibilidadMovimientos(datoHijo) {
		console.log("Inicio metodo 'visibilidadMovimientos' del componente 'ShowCardsComponent'");

		this.visualizaMovimientos = datoHijo;

		console.log("Fin metodo 'visibilidadMovimientos' del componente 'ShowCardsComponent'");
	}

    /**
     * Comprueba si el identificador de una ciudad está en la lista de ciudades a las que se permite realizar descargas
     * @param idCity
     */
	public isTopupAvailableInCity() {
		return this.topUpAvailablesCitiesList.indexOf(idCiudadLiferay) > -1;
	}

	// Nos permite saber a donde redirigir al estudiante en funcion de la ciudad en la que nos encontramos
	public editStudentCard() {
		var city = "";
		switch (idCiudadLiferay) {
			case "1":
				city = "marrakech";
				break;
			case "2":
				city = "agadir";
				break;
			case "3":
				city = "tanger";
				break;
			case "4":
				city = "khouribga";
				break;
			case "5":
				city = "rabat";
				break;
			case "6":
				city = "casablanca";
				break;
		}
		window.location.href = "/" + city + "/espace-etudiant";
	}
	
	
	
	//Metodo que lleva a pantalla para descarga de tarjeta duplicada por perdida o rotura
	public retrieveStudentCard(numCard: string) {	
		const myUrlWithParams = new URL(URLLostCardPage);
		myUrlWithParams.searchParams.append("code", numCard);		
		window.location.href = myUrlWithParams.href;	
	}

	
	// Devuelve el numero de tarjeta mas reciente, esto es en caso de que un estudiante haya perdido
	// La tarjeta original y le hayan sacado otra con el mismo numero de dossier
	public getLastCardNumber(actualCard) {
		if (actualCard.numero_carte_3) {
			return actualCard.numero_carte_3;
		}
		if (actualCard.num_carte_duplicata) {
			return actualCard.num_carte_duplicata;
		}
		if (actualCard.num_carte_etudiant) {
			return actualCard.num_carte_etudiant;
		}
	}

	/*--------------------------------------------- Eventos ------------------------------------------------------*/
	ngOnInit() {
		this.namespacePortlet = studentDesktopNamespace;
		this.initSelects();
		this.topUpCardURL = topUpCardURL;
		this.cardNumberParam = cardNumberParam;
		try {
			this.topUpAvailablesCitiesList = JSON.parse(topUpAvailablesCitiesListJson);
		} catch (err) {
			this.topUpAvailablesCitiesList = new Array();
		}
	}

	constructor(@Inject(Http) private ajaxRequest) { }
}



// WEBPACK FOOTER //
// ./src/app/show-cards/show-cards.component.ts